import { useEffect, useState } from "react";
import ProfileLayout from "./layout";
import { Tabs, Tab, Container } from "react-bootstrap";
import {
  useNotifChannel,
  useMailTarget,
} from "contexts/v1/pages/NotifChannelContext";
import Swal from "sweetalert2";
import SmtpForm from "./component/SmtpForm";
// import { useMailTarget } from "contexts/v1/pages/MailTargetContext";

const WhatsAppForm = () => {
  const { notifChannels, createNotifChannel, refetch } = useNotifChannel(); // Ambil refetch dari context
  console.log("NotifChannel", notifChannels);

  // Inisialisasi formData dengan nilai yang ada di notifChannels
  const [formData, setFormData] = useState({
    api_key: "",
    url: "",
    sender: "",
  });

  // Gunakan useEffect untuk mengupdate formData jika notifChannels berubah
  useEffect(() => {
    if (notifChannels && notifChannels.data) {
      setFormData({
        api_key: notifChannels.data?.setting?.api_key || "",
        url: notifChannels.data?.setting?.url || "",
        sender: notifChannels.data?.setting?.sender || "",
      });
    }
  }, [notifChannels]); // Akan terpicu setiap kali notifChannels berubah

  // Handle perubahan input form
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // Handle submit form untuk menyimpan perubahan
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Kirim request untuk create/update data melalui API
      const response = await createNotifChannel(formData); // Gunakan await untuk menunggu hasil dari createNotifChannel

      if (response.success) {
        Swal.fire("Saved!", "Your changes have been saved.", "success");
        // Setelah berhasil disubmit, lakukan refetch data
        refetch();
      } else {
        Swal.fire("Error!", response.message, "error");
      }
    } catch (error) {
      Swal.fire("Error!", error.message, "error");
    }
  };

  return (
    <div className="m-4">
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label htmlFor="api_key" className="form-label">
            API Key
          </label>
          <input
            type="text"
            className="form-control"
            id="api_key"
            name="api_key"
            placeholder="Enter your API Key"
            value={formData.api_key} // Set nilai default
            onChange={handleChange} // Panggil handleChange
          />
        </div>
        <div className="mb-3">
          <label htmlFor="url" className="form-label">
            URL
          </label>
          <input
            type="text"
            className="form-control"
            id="url"
            name="url"
            placeholder="Enter your URL"
            value={formData.url} // Set nilai default
            onChange={handleChange} // Panggil handleChange
          />
        </div>
        <div className="mb-3">
          <label htmlFor="sender" className="form-label">
            Sender
          </label>
          <input
            type="text"
            className="form-control"
            id="sender"
            name="sender"
            placeholder="Enter your Sender"
            value={formData.sender} // Set nilai default
            onChange={handleChange} // Panggil handleChange
          />
        </div>
        <button type="submit" className="btn btn-primary">
          Save
        </button>
      </form>
    </div>
  );
};

const MailTargetForm = () => {
  const { mailTargets, createMailTarget, refetch } = useMailTarget(); // Mendapatkan fungsionalitas dari hook
  // console.log("MailTarget", mailTargets);
  const [formData, setFormData] = useState({
    url: "",
    access_token: "",
    from_address: "",
    from_name: "",
  });

  // Gunakan useEffect untuk mengupdate formData jika berubah
  useEffect(() => {
    if (mailTargets && mailTargets.data) {
      setFormData({
        url: mailTargets.data?.setting?.url || "",
        access_token: mailTargets.data?.setting?.access_token || "",
        from_address: mailTargets.data?.setting?.from_address || "",
        from_name: mailTargets.data?.setting?.from_name || "",
      });
    }
  }, [mailTargets]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await createMailTarget(formData); // Menggunakan createMailTarget
      if (response.success) {
        Swal.fire("Success!", response.message, "success");
        console.log("Mail Target created successfully", response);
        refetch(); // Refetch data untuk mendapatkan data terbaru
      } else {
        Swal.fire("Error!", response.message, "error");
      }
    } catch (error) {
      alert("Error: " + error.message);
    }
  };

  return (
    <div className="m-4">
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label htmlFor="url" className="form-label">
            URL
          </label>
          <input
            type="text"
            className="form-control"
            id="url"
            name="url"
            value={formData.url}
            onChange={handleChange}
            placeholder="Enter URL"
          />
        </div>
        <div className="mb-3">
          <label htmlFor="access_token" className="form-label">
            Access Token
          </label>
          <input
            type="text"
            className="form-control"
            id="access_token"
            name="access_token"
            value={formData.access_token}
            onChange={handleChange}
            placeholder="Enter Access Token"
          />
        </div>
        <div className="mb-3">
          <label htmlFor="from_address" className="form-label">
            From Address
          </label>
          <input
            type="text"
            className="form-control"
            id="from_address"
            name="from_address"
            value={formData.from_address}
            onChange={handleChange}
            placeholder="Enter From Address"
          />
        </div>
        <div className="mb-3">
          <label htmlFor="from_name" className="form-label">
            From Name
          </label>
          <input
            type="text"
            className="form-control"
            id="from_name"
            name="from_name"
            value={formData.from_name}
            onChange={handleChange}
            placeholder="Enter From Name"
          />
        </div>
        <button type="submit" className="btn btn-primary">
          Save
        </button>
      </form>
    </div>
  );
};

const NotifChannel = () => {
  const [key, setKey] = useState("whatsapp"); // State untuk tab aktif

  return (
    <ProfileLayout>
      <Container className="mt-4">
        <h2>Notif Channel</h2>
        <Tabs
          id="notif-channel-tabs"
          activeKey={key}
          onSelect={(k) => setKey(k)}
          className="mb-3"
          fill
        >
          <Tab eventKey="whatsapp" title="Whatsapp">
            {/* <div>Konten untuk tab Whatsapp</div> */}
            <WhatsAppForm />
          </Tab>
          <Tab eventKey="email" title="Our Email">
            {/* <div>Konten untuk tab Our Email</div> */}
            <MailTargetForm />
          </Tab>
          <Tab eventKey="smtp" title="SMTP Mail">
            {/* <div>Konten untuk tab SMTP Mail</div> */}
            <SmtpForm />
          </Tab>
          <Tab eventKey="others" title="Others">
            <div>Welcome Konten untuk tab Others</div>
          </Tab>
        </Tabs>
      </Container>
    </ProfileLayout>
  );
};
// Styling untuk panel konten
// const panelStyle = {
//   padding: "20px",
//   border: "1px solid #ddd",
//   borderRadius: "4px",
//   backgroundColor: "#f9f9f9",
//   height: "300px", // Sesuaikan tinggi panel
//   overflowY: "auto",
// };
export default NotifChannel;
